import React from "react";
import styled from "@emotion/styled";
import Grid from "@material-ui/core/Grid";
import logoimg from "../../img/logo.png";
import ISO from "../../img/ISO.png";

import { Container } from "@mui/material";

const DIV = styled.div`
display: grid;
font-size: 16px;
`;
const MainDiv = styled.div`
background-color: #b82e3c;
color: #ffffff;
/* text-align-last: center; */
`;
const H4 = styled.h4`
font-weight: 600;
@media screen and (max-width:599px){
  display: none;
}
`;
const P = styled.p`
color:#ffffff
`;
const ImageDiv = styled.div`
@media screen and (max-width:599px){
  padding: 0 0 30px;
  
}`

const ISodiv = styled.div`

    display: flex;
    text-align: center;
padding: 0 16px 0 13px;
font-weight: bolder;
`
const IsoImage = styled.img`
width:100%;
Height:auto;
max-width:100px ;
@media screen and (max-width:599px){
  padding: 20px 0 0;
}
`;
const Footer = () => {
  return (
    <div>
    <MainDiv className="d-block py-5" id="contact">
      <Container maxWidth="xl" className="">
        <Grid container alignItems="center" >
          <Grid xs={12} sm={5}>
            <ImageDiv>
              <img src={logoimg} className="img-fluid mx-auto" style={{ maxWidth: "200px" }}  />
              </ImageDiv>
              </Grid>
          <Grid xs={12} sm={5}>
          <H4 className="mt-0">CONTACT US</H4>
          <DIV>
          <span>Tel: +92 51 220 3122</span>
          <span>Email: info@fourbrothers.com.pk</span>
          </DIV>
          </Grid>
          <Grid xs={12} sm={2}>
          <IsoImage src={ISO} className="img-fluid mx-auto"  />
          <ISodiv>
          ISO 9001 <br/>
          CERTIFIED
          </ISodiv>
          </Grid>
        </Grid>
      </Container>
    </MainDiv>
    <Container>
    <div className="py-3 text-center" style={{backgroundColor:'black'}}>
    <P>© Copyright Four Brothers, Pakistan 2022. All Rights Reserved</P>
    </div>
    </Container>
    </div>
  );
};

export default Footer;
